import Vue from 'vue'

export const modalStore = {
    state: Vue.observable({
        opened: false,
        component: '',
        data: {},
    }),

    open (component, data) {
        if (!this.state.opened) {
            document.querySelector('body').classList.add('overflow-hidden')
        }
        this.state.component = component
        this.state.data = data
        this.state.opened = true
    },

    updateData(data) {
        Object.assign(this.state.data,data)
    },

    close () {
        if (this.state.opened) {
            document.querySelector('body').classList.remove('overflow-hidden')
        }
        this.state.opened = false
    },

    confirm (data = {}) {
        this.open('ui-modal-confirm', data)
    },

    confirmDelete (data = {}) {
        this.open('ui-modal-delete', data)
    },

    sign (data = {}) {
        this.open('ui-modal-sign', data)
    },

    wait (data = {}) {
        this.open('ui-modal-wait', data)
    },

    info (data = {}) {
        this.open('ui-modal-info', data)
    },

    error (data = {}) {
        this.open('ui-modal-error', data)
    },
}
